import { Action } from 'redux';
import { SiteConfig } from '../../models/SiteConfig';

export enum SiteConfigActionTypes {
  ACTION_SET_PAGE_TITLE = 'SET_PAGE_TITLE',
}

export interface ActionSetPageTitle extends Action {
  type: SiteConfigActionTypes.ACTION_SET_PAGE_TITLE;
  payload: SiteConfig;
}

export type SiteConfigActions =
  | ActionSetPageTitle
  ;